import { useState } from 'react';
import BasicModalWithConfirmation from '__components/Modals/presets/BasicModalWithConfirmation';
import { useCallback } from 'react';
import { Conversation } from 'ts-components/Conversation';
import { useQueryClient } from '@tanstack/react-query';
import MachineLearningService from 'services/MachineLearningService';
import { CHAT_BOT } from 'queries/query-keys';
export const AiChatModal = ({
  entityName,
  heading,
  show,
  onHide,
  onConfirm,
  onError,
  objectId,
  name,
  flowType,
  taskType,
  context,
  pendingMessages,
  isMobile,
  generationVarToMessageHeaderMapper,
  confirmationHeading,
  ...props
}: any) => {
  const queryClient = useQueryClient();
  const [chatSessionId, setChatSessionId] = useState<string | null>(null);
  const [isGenerationComplete, setIsGenerationComplete] = useState(false);

  const handleHide = useCallback(async () => {
    onHide();
    if (!isGenerationComplete) {
      await MachineLearningService.cancelChatSession(chatSessionId);
      queryClient.removeQueries({
        queryKey: CHAT_BOT.NEW_CHAT_SESSION(taskType, context),
      });
      queryClient.invalidateQueries({
        queryKey: CHAT_BOT.FLOW_STATUS(flowType),
      });
    }
  }, [
    flowType,
    isGenerationComplete,
    onHide,
    chatSessionId,
    queryClient,
    taskType,
    context,
  ]);

  const handleConfirm = useCallback(
    (flowStatus: any) => {
      setIsGenerationComplete(true);
      onConfirm(flowStatus);
      queryClient.invalidateQueries({
        queryKey: CHAT_BOT.FLOW_STATUS(flowType),
      });
    },
    [onConfirm, queryClient, flowType]
  );
  if (!show) {
    return null;
  }

  return (
    <BasicModalWithConfirmation
      confirmationHeading={confirmationHeading}
      onHide={handleHide}
      show={show}
      size="medium"
      heading={heading}
      hideFooter
      dirty
      typeOfContent="no-paddings"
      displayFlex
      {...props}
    >
      <div className="h-[50vh] w-full mr-[-15px] mb-[15px] overflow-y-auto">
        <Conversation
          entityName={entityName}
          inModal
          enabled={show}
          context={context}
          objectId={objectId}
          flowType={flowType}
          taskType={taskType}
          onComplete={handleConfirm}
          onSessionChange={setChatSessionId}
          onError={onError}
          pendingMessages={pendingMessages}
          generationVarToMessageHeaderMapper={
            generationVarToMessageHeaderMapper
          }
        />
      </div>
    </BasicModalWithConfirmation>
  );
};
